import Regex from '../Regex'

export default class AlphaLower extends Regex {
  get ruleName () {
    return 'alphaLower'
  }

  passes () {
    return super.passes(/^[a-zà-ÿ]+$/)
  }
}
